module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beian.png
// module id = kNcd
// module chunks = 7